import React from 'react';
import type { FC, ReactNode } from 'react';

interface ActivityIndicatorProps {
    className?: string;
}

export const ActivityIndicator: FC<ActivityIndicatorProps> = ({ className }) => {
    return (
        <svg className={className} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <title>Activity Indicator</title>
            <g clipPath="url(#clip0_5293_7504)">
                <path d="M10 5V2.5" stroke="#ffffff" strokeLinecap="square" strokeLinejoin="round">
                    <animate
                        attributeName="stroke"
                        values="#ffffff;#323840;#323840;#323840;#323840;#323840;#323840;#323840"
                        dur="2s"
                        repeatCount="indefinite"
                    />
                </path>
                <path
                    d="M13.543 6.45964L15.3346 4.66797"
                    stroke="#323840"
                    strokeLinecap="square"
                    strokeLinejoin="round"
                >
                    <animate
                        attributeName="stroke"
                        values="#323840;#ffffff;#323840;#323840;#323840;#323840;#323840;#323840"
                        dur="2s"
                        repeatCount="indefinite"
                    />
                </path>
                <path d="M15 10H17.5" stroke="#323840" strokeLinecap="square" strokeLinejoin="round">
                    <animate
                        attributeName="stroke"
                        values="#323840;#323840;#ffffff;#323840;#323840;#323840;#323840;#323840"
                        dur="2s"
                        repeatCount="indefinite"
                    />
                </path>
                <path d="M13.543 13.543L15.3346 15.3346" stroke="#323840" strokeLinecap="square" strokeLinejoin="round">
                    <animate
                        attributeName="stroke"
                        values="#323840;#323840;#323840;#ffffff;#323840;#323840;#323840;#323840"
                        dur="2s"
                        repeatCount="indefinite"
                    />
                </path>
                <path d="M10 15V17.5" stroke="#323840" strokeLinecap="square" strokeLinejoin="round">
                    <animate
                        attributeName="stroke"
                        values="#323840;#323840;#323840;#323840;#ffffff;#323840;#323840;#323840"
                        dur="2s"
                        repeatCount="indefinite"
                    />
                </path>
                <path
                    d="M6.45964 13.543L4.66797 15.3346"
                    stroke="#323840"
                    strokeLinecap="square"
                    strokeLinejoin="round"
                >
                    <animate
                        attributeName="stroke"
                        values="#323840;#323840;#323840;#323840;#323840;#ffffff;#323840;#323840"
                        dur="2s"
                        repeatCount="indefinite"
                    />
                </path>
                <path d="M5 10H2.5" stroke="#323840" strokeLinecap="square" strokeLinejoin="round">
                    <animate
                        attributeName="stroke"
                        values="#323840;#323840;#323840;#323840;#323840;#323840;#ffffff;#323840"
                        dur="2s"
                        repeatCount="indefinite"
                    />
                </path>
                <path
                    d="M6.45964 6.45964L4.66797 4.66797"
                    stroke="#323840"
                    strokeLinecap="square"
                    strokeLinejoin="round"
                >
                    <animate
                        attributeName="stroke"
                        values="#323840;#323840;#323840;#323840;#323840;#323840;#323840;#ffffff"
                        dur="2s"
                        repeatCount="indefinite"
                    />
                </path>
            </g>
            <defs>
                <clipPath id="clip0_5293_7504">
                    <rect width="20" height="20" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};
